export default [
  {
    title: "Confianza",
    text:
      "Nuestros años de trayectoria y nuestra experiencia en gestión de visas garantizan nuestros servicios.",
    image: "image_1.png",
    alt: "Medalla de reconocimiento.",
  },
  {
    title: "Planes perfectos",
    text:
      "Contamos con las mejores promociones para que puedas realizar tu visa de la mejor forma posible.",
    image: "image_2.png",
    alt: "Lampara de luz encendida.",
  },
  {
    title: "Rapidez",
    text:
      "Brindamos un servicio 100% profesional y personalizado, especialmente orientado a la satisfacción del cliente.",
    image: "image_3.png",
    alt: "Reloj",
  },
];
